import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, UncontrolledPopover, PopoverHeader, PopoverBody } from 'reactstrap';
import { Panel, PanelHeader, PanelBody } from './../../components/panel/panel.jsx';
import Chart from 'react-apexcharts';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import withNotification from '../../components/HOCNotification/HOCNotification.component';
import Services from '../../services/service';

import {
  alertEvents, 
  activityLog, 
  lvdpVoltageChart, 
  gensetTimeCycleChart, 
  electricityConsumptionChart,
  elevatorPerformanceChart,
  maintenanceChart,
} from './mock.js';

class Dashboard extends Component {
	constructor(props) {
		super(props);

		this.state = {
      dataStatusDashboard: [],
      dataStatusLighting: {
        status: 0
      },
      dataListDevices: [],
      dataComplaint: [],
      dataMaintenance: [],
      filterMaintenance: {
        asset: '',
        startDate: new Date(),
        endDate: new Date(),
      },
      maintenanceAssetsOption: [],
		};
		
		this.lineChartData = {
			labels: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
			datasets: [{
				label: 'Page Views',
				fill: false,
				lineTension: 0.1,
				backgroundColor: 'rgba(0, 172, 172, 0.25)',
				borderColor: '#00acac',
				borderWidth: 2,
				pointBorderColor: '#00acac',
				pointBackgroundColor: '#fff',
				pointBorderWidth: 2,
				pointHoverRadius: 5,
				pointHoverBackgroundColor: '#fff',
				pointHoverBorderColor: '#00acac',
				pointHoverBorderWidth: 3,
				pointRadius: 3,
				pointHitRadius: 10,
				data: [65, 59, 80, 81, 56, 55, 40, 59, 76, 94, 77, 82]
			},{
				label: 'Visitors',
				fill: false,
				lineTension: 0.1,
				backgroundColor: 'rgba(52, 143, 226, 0.25)',
				borderColor: '#348fe2',
				borderWidth: 2,
				pointBorderColor: '#348fe2',
				pointBackgroundColor: '#fff',
				pointBorderWidth: 2,
				pointHoverRadius: 5,
				pointHoverBackgroundColor: '#fff',
				pointHoverBorderColor: '#348fe2',
				pointHoverBorderWidth: 3,
				pointRadius: 3,
				pointHitRadius: 10,
				data: [25, 29, 40, 45, 16, 15, 20, 39, 26, 44, 57, 32]
			}]
		}
		
		this.lineChartOptions = { 
			maintainAspectRatio: false, 
			scales: { 
				yAxes: [{ 
					ticks: { 
						beginAtZero:true,
						fontColor: 'black'
					}
				}],
				xAxes: [{ 
					ticks: { 
						fontColor: 'black'
					}
				}]
			},
			legend: {
				labels: {
					fontColor: 'black'
				}
			}
		}

	}

  componentDidMount(){
    this.getDataDashboard();
    this.getDataLighting();
    this.getDataDevices();
    this.getDataComplaint();
    this.getDataMaintenance();
    this.getMaintenanceAssetsOption();
  };

  getDataComplaint = () => {
    const { startDate, endDate } = this.state;
    const param = { params: { startDate, endDate }};
    Services.getComplaintList(param)
      .then(res => {
        this.setState({dataComplaint: res});
      })
      .catch(err => console.log(err))
  };

  getDataDashboard = () => {
    const params = {
      dataselection: "totalasset,totalassetactive,totalassetnotactive,totalassetrepair"
    };

    Services.getDashboardStatus(params)
      .then(res => {
        this.setState({dataStatusDashboard: res});
      })
      .catch(err => {
        this.props.addNotification('danger', 'Failed', 'Something went wrong !', 'top-right');
      });
  };

  getDataDevices = () => {
    Services.getListDevice()
      .then(res => {
        this.setState({dataListDevices: res.data});
      })
      .catch(err => {
        this.props.addNotification('danger', 'Failed', 'Something went wrong !', 'top-right');
      });
  };

  getDataLighting = () => {
    Services.getLightingStatus()
      .then(res => {
        this.setState({dataStatusLighting: res});
      })
      .catch(err => {
        this.props.addNotification('danger', 'Failed', 'Something went wrong !', 'top-right');
      })
  };

  getMaintenanceAssetsOption = () =>{
    Services.getList({param: 'parameter-module-data-assets-dashboard'}).then(res => {
      this.setState({maintenanceAssetsOption: res});
    }).catch(err =>{
      console.log('failed to get maintenance assets option',err)
      this.props.addNotification('danger', 'Failed', 'Failed to get Maintenance Assets Option');
    })
  }

  getDataMaintenance = () => {
    const {filterMaintenance} = this.state;
    if(!filterMaintenance.asset || !filterMaintenance.startDate || !filterMaintenance.endDate){
      return this.setState({dataMaintenance: maintenanceChart.series});
    }
    const params = {
      assetId: filterMaintenance.asset,
      startDate: moment(filterMaintenance.startDate).format("YYYY-MM-DD"),
      endDate: moment(filterMaintenance.endDate).format("YYYY-MM-DD"),
    };
    Services.getDashboardAssetSummary(params)
      .then(res => {
        this.setState({dataMaintenance: res.data});
      })
      .catch(err => {
        this.setState({dataMaintenance: maintenanceChart.series});
        this.props.addNotification('danger', 'Failed', 'Failed to get Progress Checklist Maintenance.', 'top-right');
      });
  }

  setStatusDevice = (item) => {
    const { fetchDevId, status } = item;
    // console.log("fetchDevId", fetchDevId);
    const payload = {
      newValue: status === 2 ? 1 : 2,
    }
  
    Services.setStatusDevice(payload, fetchDevId)
    .then(res => {
      this.getDataDevices();
    })
    .catch(err => {
      this.props.addNotification('danger', 'Failed', 'Something went wrong !', 'top-right');
    })
  };

  renderDashboardStatus = () => {
    const { dataStatusDashboard } = this.state;
    return(
      <div className="row">
        <div className="col-xl-3 col-md-6">
          <div className="widget widget-stats bg-grey-darker">
            <div className="stats-icon"><i className="fa fa-desktop"></i></div>
            <div className="stats-info">
              <h4>TOTAL ASET</h4>
              <p>{dataStatusDashboard.totalAssets}</p>	
            </div>
            <div className="stats-link">
              <Link to="/master/asset-management">View Detail <i className="fa fa-arrow-alt-circle-right"></i></Link>
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-md-6">
          <div className="widget widget-stats bg-black-lighter">
            <div className="stats-icon"><i className="fa fa-link"></i></div>
            <div className="stats-info">
              <h4>ASET AKTIF</h4>
              <p>{dataStatusDashboard.totalActiveAssets}</p>	
            </div>
            <div className="stats-link">
              <Link to="/master/asset-management/Active">View Detail <i className="fa fa-arrow-alt-circle-right"></i></Link>
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-md-6">
          <div className="widget widget-stats bg-grey-darker">
            <div className="stats-icon"><i className="fa fa-desktop"></i></div>
            <div className="stats-info">
              <h4>ASET DIPERBAIKI</h4>
              <p>{dataStatusDashboard.totalRepairAssets}</p>	
            </div>
            <div className="stats-link">
              <Link to="/master/asset-management/Repair">View Detail <i className="fa fa-arrow-alt-circle-right"></i></Link>
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-md-6">
          <div className="widget widget-stats bg-black-lighter">
            <div className="stats-icon"><i className="fa fa-clock"></i></div>
            <div className="stats-info">
              <h4>ASET RUSAK</h4>
              <p>{dataStatusDashboard.totalNotActiveAssets}</p>	
            </div>
            <div className="stats-link">
              <Link to="/master/asset-management/Not+Active">View Detail <i className="fa fa-arrow-alt-circle-right"></i></Link>
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderCardPanel = () => {
    const { dataStatusLighting } = this.state;

    return (
      <PanelBody>
        <Card
          className="border-1 card-inverse text-black"
          style={{ borderBottomLeftRadius: 0, borderBottomRightRadius: 0}}
        >
          <CardBody>
            <div className="row d-flex justify-content-around">
              <div>
                <div className="ml-2">
                  <label className="mr-0">Temperature</label>
                </div>
                <div className="ml-2">
                  <label className="page-header">{ `${dataStatusLighting?.temperature}°` }</label>
                </div>
              </div>
              <div>
                <div className="ml-2">
                  <label className="mr-0">Status</label>
                </div>
                <div className="ml-2">
                  <label className="page-header">{ dataStatusLighting?.status ? 'ON' : 'OFF'} </label>
                </div>
              </div>
            </div>
          </CardBody>
        </Card>
        <Card
          className="border-1 card-inverse text-black"
          style={{ borderBottomLeftRadius: 0, borderBottomRightRadius: 0 }}
        >
          <CardBody>
            <div className="d-flex justify-content-center align-content-center align-baseline">
              <div className="align-self-center">
                  <label className="page-header">Set Status</label>
                  <div className="col-md-9 p-t-3">
                    <div className="switcher align-self-center">
                      <input 
                        type="checkbox"
                        name="switcher_checkbox_lighting"
                        id="switcher_checkbox_lighting" 
                        // defaultChecked={dataStatusLighting?.status}
                        checked={dataStatusLighting?.status}
                        onClick={() => this.setState({
                          dataStatusLighting: {...dataStatusLighting, status: dataStatusLighting.status ? 0 : 1}
                        })}
                        onChange={()=>{return;}}
                        //onClick={this.setStatusLighting}
                      />
                      <label htmlFor="switcher_checkbox_lighting"></label>
                    </div>
                </div>
              </div>
            </div>
          </CardBody>
        </Card>
      </PanelBody>
    )
  };

  renderDevicesPanel = (item, index) => (
    <div key={index} className="col-xl-6" style={{ paddingTop: 10 }}>
        <Card
          className="border-1 card-inverse text-black"
          style={{ borderBottomLeftRadius: 0, borderBottomRightRadius: 0 }}
        >
          <CardBody>
            <div className="d-flex column justify-content-around align-baseline">
              <div className="d-flex flex-wrap justify-content-around align-items-center">
                  <label className="page-header align-self-center">{item.title}</label>
                  <div className="switcher align-self-center" style={{ padding: 8 }}>
                    <input
                      type="checkbox"
                      name={`switcher_checkbox_${index}`}
                      id={`switcher_checkbox_${index}`}
                      // defaultChecked={item?.status === 1}
                      // checked={item?.status === 2}
                      // onChange={()=>{return;}}
                    />
                    <label htmlFor={`switcher_checkbox_${index}`} onClick={() => this.setStatusDevice(item)}></label>
                  </div>
              </div>
              <div className="d-flex flex-wrap column align-items-center">
                <div className="ml-2">
                  <label className="mr-0">Status</label>
                </div>
                <div className="ml-2">
                  {/* <label className="page-header">{ item?.status === 2 ? 'ON' : 'OFF' }</label> */}
                  <label className="page-header">{ document.getElementById(`switcher_checkbox_${index}`)?.checked ? 'ON' : 'OFF' }</label>
                </div>
              </div>
            </div>
          </CardBody>
        </Card>
    </div>
  );

  renderActivityLog = (title, data) => {
    const titleId = title.replace(/\W+/g, '-').toLowerCase();
    return (
      <div className="col-xl-4 col-lg-4">
        <div className="card border-0 bg-dark text-white mb-3">
          <div className="card-body" style={{height: 300}}>
            <div className="mb-3 text-grey">
              <b>{title}</b>
              <span className="ml-2">
                <i className="fa fa-info-circle" id={`popover-${titleId}`}></i>
                <UncontrolledPopover trigger="hover" placement="top" target={`popover-${titleId}`}>
                  <PopoverHeader>{title}</PopoverHeader>
                  <PopoverBody>Lorem ipsum dolor sit amet.</PopoverBody>
                </UncontrolledPopover>
              </span>
            </div>
            {data && data.map((d, idx) => (
              <div key={idx} className="d-flex align-items-center m-b-15">
                <div className="text-center mr-3">
                  <div className="badge f-s-13" style={{background: d.color ? d.color : "auto"}}>{d.label}</div>
                </div>
                <div className="ml-auto text-truncate">
                  <div>{d.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    )
  };

  renderElevatorPerformance = () => (
    <div className="card border-0 bg-dark text-white text-truncate mb-3">
      <div className="card-body">
        <div className="mb-2 text-grey">
          <b>Elevator Performance</b> 
          <span className="ml-2">
            <i className="fa fa-info-circle" id="popover-elevator-pf"></i>
            <UncontrolledPopover trigger="hover" placement="top" target="popover-elevator-pf">
              <PopoverHeader>Elevator Performance</PopoverHeader>
              <PopoverBody>Lorem ipsum dolor sir amet.</PopoverBody>
            </UncontrolledPopover>
          </span>
        </div>
        <div>
          <Chart type="radialBar" width="100%" height={250} options={elevatorPerformanceChart.options} series={elevatorPerformanceChart.series} />
        </div>
      </div>
    </div>
  )

  renderLVDPVoltage = () => (
    <div className="card border-0 bg-dark text-white text-truncate mb-3">
      <div className="card-body">
        <div className="mb-2 text-grey">
          <b>LVDP Voltage 3 Phase</b> 
          <span className="ml-2">
            <i className="fa fa-info-circle" id="popover-lvdp"></i>
            <UncontrolledPopover trigger="hover" placement="top" target="popover-lvdp">
              <PopoverHeader>LVDP Voltage 3 Phase</PopoverHeader>
              <PopoverBody>Lorem ipsum dolor sir amet.</PopoverBody>
            </UncontrolledPopover>
          </span>
        </div>
        <div>
          <Chart type="line" width="100%" height={250} options={lvdpVoltageChart.options} series={lvdpVoltageChart.series} />
        </div>
      </div>
    </div>
  )
  
  renderElectricityConsumption = () => (
    <div className="card border-0 bg-dark text-white text-truncate mb-3">
      <div className="card-body">
        <div className="mb-2 text-grey">
          <b>Electricity Consumption</b> 
          <span className="ml-2">
            <i className="fa fa-info-circle" id="popover-elec-con"></i>
            <UncontrolledPopover trigger="hover" placement="top" target="popover-elec-con">
              <PopoverHeader>Electricity Consumption</PopoverHeader>
              <PopoverBody>Lorem ipsum dolor sir amet.</PopoverBody>
            </UncontrolledPopover>
          </span>
        </div>
        <div>
          <Chart width="100%" height={250} options={electricityConsumptionChart.options} series={electricityConsumptionChart.series} />
        </div>
      </div>
    </div>
  )

  renderGensetTimeCycle = () => (
    <div className="card border-0 bg-dark text-white text-truncate mb-3">
      <div className="card-body">
        <div className="mb-2 text-grey">
          <b>Genset Time Cycle</b> 
          <span className="ml-2">
            <i className="fa fa-info-circle" id="popover-genset-time"></i>
            <UncontrolledPopover trigger="hover" placement="top" target="popover-genset-time">
              <PopoverHeader>Genset Time Cycle</PopoverHeader>
              <PopoverBody>Lorem ipsum dolor sir amet.</PopoverBody>
            </UncontrolledPopover>
          </span>
        </div>
        <div>
          <Chart type="bar" width="100%" height={250} options={gensetTimeCycleChart.options} series={gensetTimeCycleChart.series} />
        </div>
      </div>
    </div>
  );

  renderMaintenanceChart = () => {
    const {dataMaintenance, maintenanceAssetsOption, filterMaintenance} = this.state;
    
    const handleFilterChange = (e) => {
      const {name, value} = e.target;
      
      this.setState({filterMaintenance: {...filterMaintenance, [name]: value}}, () => {
        this.getDataMaintenance();
      });
    }
    
  const handleMaintenanceDateChange = (name, date) => {
    if (name === 'startDate' && date.getTime() > filterMaintenance.endDate.getTime()) {
      const newFilter = {
        ...filterMaintenance,
        [name]: date, 
        endDate: date,
      }
      this.setState({filterMaintenance: newFilter }, () => {
        this.getDataMaintenance();
      });
    } else {
      const newFilter = {
        ...filterMaintenance,
        [name]: date,
      }
      this.setState({filterMaintenance: newFilter }, () => {
        this.getDataMaintenance();
      });
    }
  };

    return (
      <div className="card border-0 bg-dark text-white text-truncate mb-3">
        <div className="card-body">
          <div className="mb-2 text-grey">
            <b>Progress Checklist Maintenance</b> 
            <span className="ml-2">
              <i className="fa fa-info-circle" id="popover-genset-time"></i>
              <UncontrolledPopover trigger="hover" placement="top" target="popover-genset-time">
                <PopoverHeader>Progress Checklist Maintenance</PopoverHeader>
                <PopoverBody>Lorem ipsum dolor sir amet.</PopoverBody>
              </UncontrolledPopover>
            </span>
          </div>
          <div className='row mb-2'>
            <div className='col-md-6'>
              <div className='row'>
                <div className='col-form-label col-auto'>Aset</div>
                <div className='col-lg-10'>
                  <select
                    className="form-control"
                    type="select"
                    name="asset"
                    onChange={handleFilterChange}
                  >
                    <option value="">Pilih Aset...</option>
                    {maintenanceAssetsOption.map((data, idx) => (
                      <option key={idx} value={data._id}>{data.name}</option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <div className='col-md-6'>
              <div className='row'>
                <div className='col-form-label col-auto'>Tanggal</div>
                <div className='col-auto'>
                  <div className="input-group">
                    <DatePicker
                      className="form-control"
                      dateFormat="dd/MM/yyyy"
                      selected={this.state.filterMaintenance.startDate} 
                      onChange={(date) => handleMaintenanceDateChange("startDate", date)}
                      selectsStart
                      startDate={this.state.filterMaintenance.startDate}
                      endDate={this.state.filterMaintenance.endDate}
                      onKeyDown={(e) => {
                        e.preventDefault();
                      }}
                    />
                    <div className="input-group-append">
                      <span className="input-group-text">s.d.</span>
                    </div>
                    <DatePicker 
                      className="form-control"
                      dateFormat="dd/MM/yyyy"
                      selected={this.state.filterMaintenance.endDate} 
                      onChange={(date) => handleMaintenanceDateChange("endDate", date)} 
                      selectsEnd
                      startDate={this.state.filterMaintenance.startDate}
                      endDate={this.state.filterMaintenance.endDate}
                      minDate={this.state.filterMaintenance.startDate}
                      onKeyDown={(e) => {
                        e.preventDefault();
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <Chart type="bar" width="100%" height={250} options={maintenanceChart.options} series={dataMaintenance} />
          </div>
        </div>
      </div>
    )
  };

  renderCardCore = () => {
    const { dataListDevices } = this.state;

    return (
      <Panel>
        <PanelHeader noButton={true}>Core Base Integration</PanelHeader>
        <div className="row d-flex flex-wrap">
          <div className="col-xl-6">
            {this.renderCardPanel()}
          </div>
          <div className="row d-flex flex-wrap col-xl-6">
            {
              dataListDevices?.map((item, index) => {
                return this.renderDevicesPanel(item, index);
              })
            }
          </div>
        </div>
      </Panel>
    )
  };
  
	render() {
		return (
			<div>
				<ol className="breadcrumb float-xl-right">
					<li className="breadcrumb-item"><Link to="/dashboard/v1">Home</Link></li>
					<li className="breadcrumb-item active">Dashboard</li>
				</ol>
				<h1 className="page-header">Dashboard</h1>
				{this.renderDashboardStatus()}
				<div className="row">
          <div className='col-xl-12'>
            {this.renderCardCore()}
          </div>
          
          {this.renderActivityLog('Alert Event', alertEvents)}
          {this.renderActivityLog('Activity Log', activityLog)}
          <div className="col-xl-4 col-lg-4">
            {this.renderElevatorPerformance()}
					</div>
          <div className="col-xl-4 col-lg-4">
            {this.renderLVDPVoltage()}
          </div>
          <div className="col-xl-4 col-lg-4">
            {this.renderElectricityConsumption()}
          </div>
          <div className="col-xl-4 col-lg-4">
            {this.renderGensetTimeCycle()}
          </div>
          <div className="col-xl-12 col-lg-12">
            {this.renderMaintenanceChart()}
          </div>
				</div>
			</div>
		)
	}
};

export default withNotification(Dashboard);